import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {TableGuestsWrapper} from '../Tables/TableGuests'
import {FormMasiveUploadGuest} from '../Forms/FormMasiveUploadGuest'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'

const HeaderGuestPanel: FC = () => {
  const {isAllowed} = useHoteleria()
  return (
    <>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Huéspedes</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableGuestsWrapper />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <FormMasiveUploadGuest />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  )
}

export {HeaderGuestPanel}
